import { ScrollArea } from '@/modules/shared/components/ui/scroll-area'
import { Skeleton } from '@/modules/shared/components/ui/skeleton'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/modules/shared/components/ui/table'
import { formatDateBy } from '@/modules/shared/utils/dateFormatter'
import { numberFormatter } from '@/modules/shared/utils/formatter'

import { useProductDetailsHistoryHook } from '../hooks/use-product-details-history.hook'

export function ProductDetailsOrderHistoryComponent() {
	const { dataHistory } = useProductDetailsHistoryHook()

	return (
		<ScrollArea className="h-[50vh]">
			<Table>
				<TableHeader>
					<TableRow className='text-xs'>
						<TableHead>Pedido</TableHead>
						<TableHead>Qtd</TableHead>
						<TableHead>Data</TableHead>
						<TableHead>Vr</TableHead>
						<TableHead>Desc</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{dataHistory
						? dataHistory.map((product) => (
							<TableRow key={product.idPedido} className='text-xs'>
								<TableCell>{product.idPedido}</TableCell>
								<TableCell>{product.quantidade}</TableCell>
								<TableCell>
									{formatDateBy(product.dataEmissao, 'DD/MM/YY')}
								</TableCell>
								<TableCell>
									{numberFormatter.format(product.valorUnitario)}
								</TableCell>
								<TableCell>
									{numberFormatter.format(product.porcDesconto)}%
								</TableCell>
							</TableRow>
						))
						: Array.from({
							length: 5,
						}).map((_, index) => {
							return (
								<TableRow key={index}>
									<TableCell>
										<Skeleton className="h-5" />
									</TableCell>
									<TableCell>
										<Skeleton className="h-5" />
									</TableCell>
									<TableCell>
										<Skeleton className="h-5" />
									</TableCell>
									<TableCell>
										<Skeleton className="h-5" />
									</TableCell>
								</TableRow>
							)
						})}
				</TableBody>
			</Table>
		</ScrollArea>
	)
}
